<div class="cart-page">

  <!-- HEADER -->

  <div class="cart-header">

    <div>

      <p class="mini-title">
        {{ t('shoppingCart') }}
      </p>

      <h1 class="title">

        <i class="fa-solid fa-cart-shopping"></i>

        {{ t('myCart') }}

      </h1>

      <span class="sub">
        {{ t('reviewCartSubtitle') }}
      </span>

    </div>

    <!-- TOP SUMMARY -->

    <div class="cart-summary">

      <div class="summary-box">

        <span>{{ t('items') }}</span>

        <h3>
          {{ items.length }}
        </h3>

      </div>

      <div class="summary-box">

        <span>{{ t('total') }}</span>

        <h3>
          {{ getTotal() | bnNumber:'৳ ' }}
        </h3>

      </div>

    </div>

  </div>

  <!-- EMPTY -->

  <div
    *ngIf="items.length === 0"
    class="empty"
  >

    <i class="fa-solid fa-cart-shopping"></i>

    <h2>
      {{ t('cartEmpty') }}
    </h2>

    <p>
      {{ t('addProductsContinue') }}
    </p>

  </div>

  <!-- CART LAYOUT -->

  <div
    class="cart-layout"
    *ngIf="items.length > 0"
  >

    <!-- LEFT SIDE -->

    <div class="cart-list">

      <div
        class="cart-item"
        *ngFor="let p of items"
      >

        <!-- ICON -->

        <div class="icon">

          {{ p.name[0] }}

        </div>

        <!-- INFO -->

        <div class="info">

          <h4>
            {{ languageService.productName(p) }}
          </h4>

          <p>
            {{ p.price | bnNumber:'৳ ' }}
          </p>

        </div>

        <!-- QTY -->

        <div class="qty">

          <button (click)="dec(p)">
            −
          </button>

          <span>
            {{ p.qty | bnNumber }}
          </span>

          <button (click)="inc(p)">
            +
          </button>

        </div>

        <!-- TOTAL -->

        <div class="total">

          {{ (p.price * (p.qty || 1)) | bnNumber:'৳ ' }}

        </div>

      </div>

    </div>

    <!-- RIGHT SIDE -->

    <div class="checkout-box">

      <h2>
        {{ t('orderSummary') }}
      </h2>

      <div class="summary-row">

        <span>{{ t('subtotal') }}</span>

        <strong>
          ৳ {{ getTotal() }}
        </strong>

      </div>

      <div class="summary-row">

        <span>{{ t('delivery') }}</span>

        <strong>
          {{ 60 | bnNumber:'৳ ' }}
        </strong>

      </div>

      <div class="summary-row total-row">

        <span>{{ t('total') }}</span>

        <strong>
          {{ (getTotal() + 60) | bnNumber:'৳ ' }}
        </strong>

      </div>

      <button
        class="checkout-btn"
        (click)="goCheckout()"
      >

        {{ t('proceedToCheckout') }}

      </button>

    </div>

  </div>

</div>